import { requestAndParse, requestSuccessful } from '../request';

const getAnonymizedDeviceUserCharts = async (anonymizedId?: string) => {
    const route = 'admin/get-anonymized-device-user-charts';
    const payload = { anonymizedId };

    const response = await requestAndParse(route, payload, 'GET');

    const success = requestSuccessful(response);
    const charts = (response.body?.charts ?? []) as string[];

    return { success, charts };
};

export default getAnonymizedDeviceUserCharts;
